import { defineStore } from 'pinia'
import { ref } from 'vue'
import { createEmptyProduct, type ApiProduct as ApiProduct, type Product } from '@/types/product'
import { axiosClient } from '@/utils/axios-client'

export const useProductStore = defineStore('productStore', () => {
  const organizationProducts = ref<Product[]>([])
  const projectProducts = ref<Product[]>([])

  async function fetchOrganizationProducts() {
    if (organizationProducts.value.length > 0) {
      return
    }
    const response = await axiosClient.request<ApiProduct[]>({
      url: '/idf/api/product/all',
    })

    organizationProducts.value = []

    for (const product of response.data) {
      const weight: number | null = product.gewicht == null ? null : Number(product.gewicht)

      if (weight !== null && isNaN(weight)) throw new Error('Weight is NaN')

      organizationProducts.value.push({ ...product, gewicht: weight })
    }
  }

  async function fetchProjectProducts(projectUuid: string) {
    const response = await axiosClient.request<Product[]>({
      url: `idf/api/product/project/${projectUuid}`,
    })

    const defaultProduct = createEmptyProduct()

    projectProducts.value = response.data.map(product => ({ ...defaultProduct, ...product }))

    return projectProducts.value
  }

  return {
    organizationProducts,
    projectProducts,
    fetchOrganizationProducts,
    fetchProjectProducts,
  }
})
